package one.healthium.insights.ui.content

import one.healthium.insights.domain.content.ContentOptions
import one.healthium.insights.domain.models.ContentScreenModel
import one.healthium.insights.domain.models.SavedContentModel
import one.healthium.insights.ui.models.NavBarUiModel

internal data class ContentUiState(
    val loading: Boolean = false,
    val isMetrics: Boolean = false,
    val contentOptions: ContentOptions? = null,
    val savedContentModel: SavedContentModel? = null,
    val content: ContentScreenModel? = null,
) {
    val navBar: NavBarUiModel? = content?.navbar?.let { navbarModel ->
        NavBarUiModel(
            model = navbarModel,
            savedContentModel = savedContentModel,
        )
    }
}
